/**
 * Card list in my-account page.
 */

/*global WooPayJpCC: false*/


( function ( $ ) {
	'use strict';

	// Enable Credit Card delete.
	$( document ).on( 'click', '.delete-cc', function ( e ) {
		e.preventDefault();
		var $container = $( this ).parents( '.my_woopayjp_cc' ),
			$row = $( this ).parents( 'tr' ),
			seqNo = $( this ).attr( 'data-card-id' );
		if ( window.confirm( WooPayJpCC.confirm ) ) {
			$container.block( {
				message: null,
				overlayCSS: {
					background: '#fff url(' + WooPayJpCC.ajaxLoaderImage + ') no-repeat center',
					opacity: 0.6
				}
			} );
			$.get( WooPayJpCC.endpoint, {
				action: WooPayJpCC.action_delete,
				_wpnonce: WooPayJpCC.nonce,
				card_id: seqNo
			} ).done( function ( response ) {
				if ( response.success ) {
					$row.remove();
					if ( !( $container.find( 'tbody tr' ).length ) ) {
						$( '.my_woopayjp_cc__table' ).addClass( 'my_woopayjp_cc--empty' );
					}
				} else {
					window.alert( response.message );
				}
			} ).fail( function () {
				window.alert( WooPayJpCC.failureDelete );
			} ).always( function () {
				$container.unblock();
			} );
		}
	} );

	/**
	 * Show error message
	 * @param {String} msg
	 * @param {Boolean} [error]
	 */
	function appendMessage( msg, error ) {
		var $div = $( '<div class="woopayjp-msg"><p></p><a href="#">&times;</a></div>' );
		if ( error ) {
			$div.addClass( 'woopayjp-msg--error' );
		}
		$div.find( 'p' ).text( msg );
		$( '#woopayjp-add-card-form' ).before( $div );
		setTimeout( function () {
			$div.remove();
		}, 10000 );
	}

	// Close btn
	$( document ).on( 'click', '.woopayjp-msg a', function ( e ) {
		e.preventDefault();
		$( this ).parents( '.woopayjp-msg' ).remove();
	} );

	// Register Card
	WooPayJpCC.submit = function () {
		var $form = $( '#woopayjp-add-card-form' );
		var $container = $( '.my_woopayjp_cc' );
		$container.block( {
			message: null,
			overlayCSS: {
				background: '#fff url(' + WooPayJpCC.ajaxLoaderImage + ') no-repeat center',
				opacity: 0.6
			}
		} );
		$.post( WooPayJpCC.endpoint, {
			action: WooPayJpCC.action_add,
			'_wpnonce': WooPayJpCC.nonce,
			'payjp_token': $( '#payjp_checkout_box input[name=payjp-token]' ).val()
		} ).done( function ( result ) {
			if ( result.success ) {
				$( '.my_woopayjp_cc tbody' ).append( result.html );
				$form.find( 'input[type=text]' ).val( '' );
				$( '.my_woopayjp_cc__table' ).removeClass( 'my_woopayjp_cc--empty' );
			} else {
				appendMessage( result.message, true );
			}
		} ).fail( function () {
			appendMessage( WooPayJpCC.failureAdd, true );
		} ).always( function () {
			$container.unblock();
			var $block = $( '#payjp_checkout_box' );
			$block.find( 'input[name=payjp-token]' ).val( '' );
			$block.find( 'input[type=button]' ).removeClass( 'has-token' ).val( WooPayJpCC.button_text );
		} );
	};

	WooPayJpCC.errorHandler = function ( status, error ) {
		appendMessage( error, true );

	};
} )( jQuery );

window.wooPayJpCardSubmit = function ( response ) {
	WooPayJpCC.submit();
};

window.wooPayJpCardFailed = function ( status, error ) {
	WooPayJpCC.errorHandler( status, error );
};
